import React from 'react'

import { CustomSoftwareDevelopment } from '@components/CustomSoftwareDevelopment'
import { CustomHead } from '@ui/sections/CustomHead'

function CustomSoftwareDevelopmentPage() {
  return (
    <>
      <CustomHead
        title="Modsen as a software development services provider"
        description="Discover the opportunities of custom software development at Modsen. Build a unique software product to help your business take off."
        imagePath="/images/custom-head/custom-head-software-dev.webp"
      />
      <CustomSoftwareDevelopment />
    </>
  )
}

export default CustomSoftwareDevelopmentPage
